var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsappIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M48.1709 0C58.743 0.000119762 67.3134 8.57049 67.3135 19.1426V48.4424C67.3133 59.0144 58.7429 67.5848 48.1709 67.585H19.1426C8.57051 67.5849 0.000145567 59.0144 0 48.4424V19.1426C4.70669e-05 8.57045 8.57045 3.92532e-05 19.1426 0H48.1709Z",
    fill: "#91DD5A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9206_53351)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(15.3135 15.5)",
    fill: "#E8F8DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3135 51.5C43.2546 51.5 51.3135 43.4411 51.3135 33.5C51.3135 23.5589 43.2546 15.5 33.3135 15.5C23.3724 15.5 15.3135 23.5589 15.3135 33.5C15.3135 43.4411 23.3724 51.5 33.3135 51.5Z",
    fill: "#91DD5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3137 15.5C32.518 15.5 31.7344 15.5523 30.9659 15.6524C39.7976 16.8029 46.618 24.3547 46.618 33.5C46.618 42.6453 39.7976 50.1971 30.9658 51.3476C31.7344 51.4477 32.518 51.5 33.3137 51.5C43.2548 51.5 51.3137 43.4411 51.3137 33.5C51.3137 23.5589 43.2548 15.5 33.3137 15.5Z",
    fill: "#7ED63F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3133 46.0592C30.2899 46.0592 27.3759 44.9723 25.0942 42.9958C25.0445 42.9528 24.9812 42.9287 24.9154 42.9287H21.1389C20.945 42.9287 20.8122 42.7328 20.8843 42.5526L22.1327 39.4315C22.1621 39.358 22.1577 39.2757 22.1217 39.2052C21.2256 37.4502 20.7524 35.48 20.7524 33.4984C20.7524 26.5397 26.4404 20.8844 33.4113 20.9379C40.2434 20.9903 45.8214 26.5683 45.8738 33.4003C45.9273 40.3712 40.272 46.0592 33.3133 46.0592Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3137 43.7112C30.8282 43.7112 28.4329 42.8075 26.5692 41.1665L26.0971 40.7509C25.9726 40.6413 25.8124 40.5808 25.6465 40.5808H24.5169C24.366 40.5808 24.2629 40.4285 24.3189 40.2884L24.644 39.4757C24.718 39.2908 24.7074 39.0828 24.615 38.9063L24.2593 38.2269C23.5013 36.7786 23.1006 35.1435 23.1006 33.4982C23.1006 27.8667 27.6821 23.2852 33.3135 23.2852C38.9454 23.2851 43.5266 27.8664 43.5266 33.4983C43.5266 39.1298 38.9452 43.7112 33.3137 43.7112Z",
    fill: "#7ED63F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5086 40.6974C36.1389 40.6974 35.7844 40.5828 35.4831 40.3661C31.9969 37.8576 28.9573 34.8179 26.4486 31.3315C25.9422 30.6276 26.0226 29.6691 26.6395 29.0521L29.1628 26.5289C29.6649 26.0268 30.4789 26.0268 30.981 26.5289L32.5384 28.0863C33.0405 28.5884 33.0405 29.4025 32.5384 29.9046L32.11 30.333C31.9004 30.5425 31.8379 30.8574 31.9493 31.132C32.6651 32.8969 33.9179 34.1497 35.6828 34.8655C35.9574 34.9768 36.2722 34.9143 36.4818 34.7048L36.9102 34.2764C37.4123 33.7743 38.2264 33.7743 38.7285 34.2764L40.2859 35.8338C40.788 36.3359 40.788 37.15 40.2859 37.6521L37.7627 40.1752C37.426 40.512 36.9806 40.6974 36.5086 40.6974Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9206_53351"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(15.3135 15.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsappIcon.14715e5b9e4ff8ae50eb559320c2d9e1.svg";
export { ForwardRef as ReactComponent };